<template>
  <div
    class="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex mt-6"
  >
    <div class="bg-vlight-paper px-6 py-8 lg:flex-shrink-1 lg:p-12">
      <router-link :to="sessionUrl">
        <h3
          class="text-2xl font-bebas leading-8 font-semibold text-green tracking-wider sm:text-3xl sm:leading-9"
        >
          {{ session.title }}
        </h3>
      </router-link>
      <div class="md:flex mt-4">
        <p class="text-base leading-6 text-gray-700 mt-4 lg:mt-0">
          {{ session.shortDescription }}
        </p>
      </div>

      <div class="mt-8">
        <topic-grid :session="session"></topic-grid>
      </div>
      <div class="mt-10">
        <session-compatibility-block
          :session="session"
        ></session-compatibility-block>
      </div>
    </div>
    <div
      class="py-8 px-6 text-center bg-light-paper lg:w-1/4 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12"
    >
      <img :src="previewImage" alt="" class="rounded-lg mx-auto" />

      <p class="text-lg leading-6 font-medium text-gray-900"></p>
      <div
        class="mt-4 flex items-center justify-center text-3xl leading-none font-extrabold text-gray-900 font-bebas"
      >
<!--        <span> {{ friendlyStart.hours }} </span><span v-if="friendlyStart.minute !== '00'">:{{friendlyStart.minute}}</span><span>{{friendlyStart.ampm}}</span>-->
<!--        <span class="text-lg pl-2"> ({{timezone}})</span>-->
      </div>
      <div class="mt-6">
        <router-link :to="sessionUrl">
          <a
            class="flex items-center justify-center px-5 py-3 border border-transparent text-2xl tracking-wide leading-6 font-medium rounded-md text-white  focus:outline-none focus:shadow-outline transition duration-150 ease-in-out font-bebas"
            :class="{
              'bg-darkpurple hover:bg-purple':
                session.watchStatus === 'IDLE' ||
                session.watchStatus === 'COMPLETE',
              'bg-green hover:bg-peach': session.watchStatus === 'LIVE'
            }"
          >
            {{ buttonText }}
          </a>
        </router-link>
      </div>
      <div v-if="session.watchStatus === 'IDLE'">
        <span class="inline-flex rounded-md shadow-sm mx-auto">
          <div class="mt-4">
            <button
              type="button"
              @click="setReminder"
              class="inline-flex justify-center items-center px-5 py-3
              border-transparent text-base leading-6  font-semibold  tacking-wide
                 border-b-4 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo  transition ease-in-out duration-150"
              :class="{
                'text-green border-green': scheduledReminder,
                'text-peach border-peach': !scheduledReminder
              }"
            >
              {{ reminderText }}
              <svg
                class="ml-3 -mr-1 h-5 w-5"
                :class="{ 'text-green border-green': scheduledReminder }"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                ></path>
              </svg>
            </button>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import {auth} from "../utils/firebase";
import {remindersCollection} from "../utils/firebase";
import TopicGrid from "./TopicGrid";
import SessionCompatibilityBlock from "./SessionCompatibilityBlock";
import sanityImageBuilder from "../utils/sanityImageBuilder";
import {getTimeZoneString, toFriendlyTimeAMPMObj} from "../utils/dateHelpers";

export default {
  name: "SessionScheduleBlock",
  components: {
    SessionCompatibilityBlock,
    TopicGrid
  },
  data() {
    return {
      scheduledReminder: false
    }
  },
  props: {
    session: null
  },
  computed: {
    previewImage() {
        return sanityImageBuilder
          .image(this.session.previewImage)
          .width(200)
          .height(200)
          .url();
    },

    friendlyStart() {
      return toFriendlyTimeAMPMObj(this.session.startTime)
    },
    friendlyEnd() {
      const endTime = new Date(this.session.endTime);
      const friendlyEnd = endTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      });
      return friendlyEnd;
    },
    sessionUrl() {
      return "/session/" + this.session.slug.current;
    },
    timezone() {
      return getTimeZoneString();
    },
    buttonText() {
      switch (this.session.watchStatus) {
        case "IDLE":
          return "More Details";
        case "LIVE":
          return "Live Now";
        case "COMPLETE":
          return "Watch Again";
        default:
          return "More Details";
      }
    },
    reminderText() {
      if (this.scheduledReminder) {
        return "Reminder Set"
      } else {
        return "Set Reminder"
      }
    }
  },
  mounted() {
    if (this.$store.state.user.loggedIn) {
      this.unsubscribeReminder= remindersCollection
              .where("sessionSlug", "==", this.session.slug.current)
              .where("user", "==", auth.currentUser.uid)
              .onSnapshot(querySnapshot => {
                this.scheduledReminder = !querySnapshot.empty;
              });
    }
  },
  methods: {
    setReminder() {
      if (this.scheduledReminder) {
        return;
      }
      remindersCollection.add(
        {
          user: auth.currentUser.uid,
          emailAddress: auth.currentUser.email,
          sessionSlug: this.session.slug.current
        }
      )
    }
  },
  beforeDestroy() {
    if (this.unsubscribeReminder) {
      this.unsubscribeReminder();
    }
  }
}
</script>
